import React from 'react';
import { StyleSheet } from 'react-native';
import { withRouter } from "react-router-dom";

import {ButtonImageWithText, Card, Header} from "../../../components";
import Colors from "../../../constants/Colors";

const JourneyRatingScreen = (props) => {

    return (
        <Card containerStyle={{ height: 180, margin: 20, padding: 18 }} >

            <Header text={"Feedback"} propsTextStyle={{ fontSize: 22 }} />

            <ButtonImageWithText
                text={"Queremos seu feedack!"}
                onPress={() => props.history.push("/journey/rating")}
                imageSrc={require('../../../imageImports/journeyFeedback.png')}
                propsContainerStyle={styles.buttonContainerStyle}
                propsImageStyle={styles.imageStyle}
                propsTextStyle={styles.textStyle}
            />

        </Card>
    )

}

const styles = StyleSheet.create({
    buttonContainerStyle: {
        height: 120,
        width: '94%',
        flexDirection: 'column',
        backgroundColor: Colors.cardButtonBackground,
        borderRadius: 8,
        margin: 8
    },
    imageStyle: {
        borderRadius: 8,
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0,
        width: '100%',
        height: '82%'
    },
    textStyle: {
        color: Colors.cardButtonFontColor
    }
})

export default withRouter(JourneyRatingScreen);

